export const FETCH_WAREHOUSE_INIT_ACTION = "FETCH_WAREHOUSE_INIT_ACTION";
export const FETCH_WAREHOUSE_SUCCESS_ACTION = FETCH_WAREHOUSE_INIT_ACTION + "_SUCCESS";
export const FETCH_WAREHOUSE_FAIL_ACTION = FETCH_WAREHOUSE_INIT_ACTION + "_ERROR";

export const FETCH_WAREHOUSEMATERIALS_INIT_ACTION = "FETCH_WAREHOUSEMATERIALS_INIT_ACTION";
export const FETCH_WAREHOUSEMATERIALS_SUCCESS_ACTION = FETCH_WAREHOUSEMATERIALS_INIT_ACTION + "_SUCCESS";
export const FETCH_WAREHOUSEMATERIALS_FAIL_ACTION = FETCH_WAREHOUSEMATERIALS_INIT_ACTION + "_ERROR";

export const ADD_WAREHOUSE_INIT_ACTION = "ADD_WAREHOUSE_INIT_ACTION";
export const ADD_WAREHOUSE_SUCCESS_ACTION = ADD_WAREHOUSE_INIT_ACTION + "_SUCCESS";
export const ADD_WAREHOUSE_FAIL_ACTION = ADD_WAREHOUSE_INIT_ACTION + "_ERROR";


export const ADD_WAREHOUSEIMAGE_INIT_ACTION = "ADD_WAREHOUSEIMAGE_INIT_ACTION";
export const ADD_WAREHOUSEIMAGE_SUCCESS_ACTION = ADD_WAREHOUSEIMAGE_INIT_ACTION + "_SUCCESS";
export const ADD_WAREHOUSEIMAGE_FAIL_ACTION = ADD_WAREHOUSEIMAGE_INIT_ACTION + "_ERROR";

export const EDIT_WAREHOUSEIMAGE_INIT_ACTION = "EDIT_WAREHOUSEIMAGE_INIT_ACTION";
export const EDIT_WAREHOUSEIMAGE_SUCCESS_ACTION = EDIT_WAREHOUSEIMAGE_INIT_ACTION + "_SUCCESS";
export const EDIT_WAREHOUSEIMAGE_FAIL_ACTION = EDIT_WAREHOUSEIMAGE_INIT_ACTION + "_ERROR";

export const FETCH_UNIT_INIT_ACTION = "FETCH_UNIT_INIT_ACTION";
export const FETCH_UNIT_SUCCESS_ACTION = FETCH_UNIT_INIT_ACTION + "_SUCCESS";
export const FETCH_UNIT_FAIL_ACTION = FETCH_UNIT_INIT_ACTION + "_ERROR";